/** @module Apparel/PriceList/NewFromPriceListController */
define([
    "dojo/_base/declare",
    "csi/table/NewFrom",
    "csi/xml",
    "csi/xml/Query"
], function(declare,NewFrom,xml,Query) {

    return declare(NewFrom, {

        /**
         * Filter the list of PriceLists for selection based on style type.
         * If current style's type does not support colors then don't display price lists with LatestRevision configured "by colorway".
         *
         * @param {Widget} [view]
         */
        applyActionFilters: function(view) {

            var style = this.getParent();
            var cache = this.getCache();

            var styleType = cache.getNode(style.ProductType);
            var config = cache.getNode(styleType.ProductionConfig);

            if (!config.HasColor) {
                var q = new Query();
                q.Attr("PriceForColorwayOrSKU", xml.OP_NOT_EQUALS, "PriceForColorwayOrSKU:Colorway", "Child:LatestRevision");
                view.relRoot.addQuery(q);
            }

            this.inherited(arguments);
        }

    });
});